export default __webpack_public_path__ + "images/unclassified_instruction_1-6L3ES.png";